import {
    GET_SHIP_VIA_ERROR, GET_SHIP_VIA_SUCCESS, GET_SHIP_VIA_REQUEST,
    ADD_SHIP_VIA_ERROR, ADD_SHIP_VIA_REQUEST, ADD_SHIP_VIA_SUCCESS,
    UPDATE_SHIP_VIA_ERROR, UPDATE_SHIP_VIA_SUCCESS, UPDATE_SHIP_VIA_REQUEST,
    DELETE_SHIP_VIA_SUCCESS, DELETE_SHIP_VIA_ERROR, DELETE_SHIP_VIA_REQUEST,
} from "./types";


import { BASEURL } from "../../constant/config.js";

const axios = require("axios");




export const getShipVia = (token, id) => (dispatch) => {
    dispatch({ type: GET_SHIP_VIA_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminShipVia`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { id }
    })
        .then((response) => {
            return dispatch({ type: GET_SHIP_VIA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_SHIP_VIA_ERROR,
                payload: error.response,
            });
        });
};



export const addShipVia = (token, data, id) => (dispatch) => {
    dispatch({ type: ADD_SHIP_VIA_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminShipVia`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {
            return dispatch({ type: ADD_SHIP_VIA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_SHIP_VIA_ERROR,
                payload: error.response,
            });
        });
};



export const updateShipVia = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_SHIP_VIA_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminShipVia/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {
            return dispatch({ type: UPDATE_SHIP_VIA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_SHIP_VIA_ERROR,
                payload: error.response,
            });
        });
};




export const deleteShipVia = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_SHIP_VIA_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminShipVia/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_SHIP_VIA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_SHIP_VIA_ERROR,
                payload: error.response,
            });
        });
};
